import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';
import { LoginHelper } from '@core/services/helpers/login-helper.service';
import { NavController, Platform } from '@ionic/angular';
import { AuthService } from '../core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private platform: Platform,
    private loginHelper: LoginHelper,
    private nav: NavController
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.platform.is('cordova')) {
      return true;
    }
    if (!this.auth.getState().isLogged) {
      return true;
    }

    this.nav.navigateRoot('client-area/home', {
      animationDirection: 'forward'
    });
    this.loginHelper.afterLoginNavigation();
    return false;
  }
}
